import React from 'react';
import PreviewImageSelect from 'components/select/PreviewImageSelect';
import HorizontalTable from 'components/table/HorizontalTable';
/**
 * * 운영 - 프로모션 다국어 폼
 */

const PromotionLocalizingFrom = ({}) => {
  /// 이미지 셀렉트 이벤트
  // const handleImgChange = (val, ob) => {
  //   setLangData(
  //     langData?.map(v => (v.lang === ob.title ? { ...v, [ob.name]: val } : v)),
  //   );
  // };
  return (
    <>
      <HorizontalTable>
        <>
          {/* <thead>
            <tr>
              <th className="code_name_th">다국어</th>
              <th>프로모션 배너</th>
            </tr>
          </thead>
          <tbody>
            {langData?.map(v => (
              <tr>
                <td className="code_name_td">{v.code_name}</td>
                <td className="image_td">
                  <PreviewImageSelect
                    name="design_id"
                    imgUrl={v.image_url}
                    title={v.lang}
                    value={v.design_id}
                    optionList={bannerDropList}
                    onChange={handleImgChange}
                  />
                </td>
              </tr>
            ))}
          </tbody> */}
        </>
      </HorizontalTable>
    </>
  );
};

export default PromotionLocalizingFrom;
